// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___yieGf","root__video":"style-module__root__video___ti9xp"};
    if(module.hot) {
      // 1729151132159
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  